<template>
  <v-btn v-if="applicationStatus > 0" class="ma-2" width="160" rounded outlined large disabled>カジュアル面談に<br>応募済み</v-btn>
  <v-btn v-else class="ma-2" width="160" rounded outlined large @click="onClickCasualMeeting(jobId)">カジュアル面談に<br>応募する</v-btn>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    props: {
      jobId: {
        type: String,
        required: true
      },
      applicationStatus: {
        validator: prop => typeof prop === 'number' || prop === null,
        required: true
      },
      jobType: String,
      showStatusChip: Boolean
    },
    mixins: [ComponentMixin],
    type: "molecule",
    name: "JobCasualMeetingButton",
    methods: {
      onClickCasualMeeting(jobId) {
        if (!this.$auth.isAuthenticated) {
          localStorage.setItem('nishika_redirect', window.location.href)
          this.$auth.loginWithRedirect({
            ui_locales: this.$i18n.locale,
            initialScreen: 'login',
          });
          return;
        }
        this.gtmDataLayer({
          event: "apply-1",
          jobType: this.jobType,
          isCasual: true,
        })
        this.go(`/jobs/${jobId}/casual_meetings`);
      },
    },
  }
</script>

<style scoped>

</style>
